import isEmpty from 'lodash/isEmpty'
import i18n from '@/i18n'
import isNumber from 'lodash/isNumber'

export default {
  required(v) {
    return (!!v && !!String(v).trim() && !(isNumber(v) ? false : isEmpty(v))) || i18n.t('required_input_missing')
  },
}
